const CellTypes = {
    Header: 0,
    ReadOnly: 1,
    DataCell: 2
};

export default CellTypes;
